<template>
  <div>
    <button
      type="button"
      class="btn btn-outline-secondary btn-sm download-button"
      v-on:click="downloadCsv" :disabled="loading || disabled"
      :title="title"
    >
      {{buttonText}}
    </button>
  </div>
</template>

<script>
import ChartAPI from "./chart-api";
import {mapGetters} from "vuex";

export default {
  name: "DownloadButton",
  props: {
    downloadReportType: {
      type: String,
      default: "download-sov"
    },
    urls : {
      type: Array,
      default: []
    },
    disabled: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ""
    }
  },


  data(){
    return {
      studObj: new ChartAPI(),
      loading: false,
    }
  },
  computed: {
    buttonText: function () {
      return "Скачать";
    },
    ...mapGetters(["currentProjectId"]),
  },
  methods: {
    async downloadCsv() {
      this.loading = true
      let studObj = new ChartAPI();
      await studObj.getDownloadReport(this.downloadReportType, this.urls, this.currentProjectId);
      this.loading = false;
    }
  }
}
</script>

<style scoped>

</style>